export default __webpack_public_path__ + "static/4-aa3f4eac62977c8b084f82a44d93a8f5.jpg";